export const HYPERLINK_REGEX = new RegExp(
	'^(?:(?!mailto:|javascript:|data:|vbscript:|ftp:|sftp:|tel:|ws:|wss:|file:|about:|chrome:|chrome-extension:|resource:|jar:|callto:|sip:|sms:|mms:|irc:|wsat:|scp:|smb:|afp:|nfs:|localhost))(?=.*\\.([a-zA-Z]{2,6}|\\d{1,})).*'
);

export const isValidHyperlink = (link: string): boolean => {
	return HYPERLINK_REGEX.test(link);
};
